/* 活动相关接口 */
import http from '@/utils/http-v4'
import config from '@/config/config'

const api = {
  getEventUrl: `${config.apiv4Root}/inner4/ilisten/activity/eventUrl`,
}

export async function getEventUrl(activityId) {
  return http.get(api.getEventUrl, {
    activity_id: activityId
  })
}
